import './preferences.scss';
import React from 'react';
import {Navigate, useLocation, useNavigate} from 'react-router-dom';
import Header from '../../../organisms/header/header.js';
import RoleRibbonByRole from '../../../organisms/common/role-ribbon/role-ribbon-by-role';
import decodeToken from '../../../../utils/decode-token';
import {useTranslation} from 'react-i18next';
import PreferencesHac from '../../../organisms/common/hac-preferences/org-hac-preferences';
import HacNavigation from "../../../organisms/common/hac-navigation/hac-navigation";
import { canAccessHacManagement, getHacBackPathForRole } from '../../../../utils/role-utils';
import BackButton from '../../../atoms/back-button';

const HacListPreferences = () => {
  const {t} = useTranslation();

  const token = sessionStorage.getItem('token') || null;
  const role = decodeToken(token).role;
  const location = useLocation();
  const {breadcrumbName, backPath} = location.state || {};
  const navigate = useNavigate();

  return (
    <>
      {token && canAccessHacManagement(role) ? (
        <div className="App">
          <Header/>
          <RoleRibbonByRole role={role} navigate={navigate} translate={t} />
          <main>
            <section
              className={`${canAccessHacManagement(role) ? 'no-bg' : ''}`}>
              <div
                className="inner menu">
                <HacNavigation />
                <main className="">
                  <BackButton
                    fallbackTo={backPath || getHacBackPathForRole(role)}
                    context={breadcrumbName}
                  />
                  <h4>{t('pma-preferences-title')}</h4>
                  <main className="preferences">
                    <PreferencesHac/>
                  </main>
                </main>
              </div>
            </section>
          </main>
        </div>
      ) : (
        <Navigate to="/login"/>
      )}
    </>
  );
};

export default HacListPreferences;
